module.exports = __webpack_public_path__ + "img/myrice.e7d9d38b.png";